// extracted by mini-css-extract-plugin
export default {"wrapper":"DesktopMenu_wrapper__0SLW6","step":"DesktopMenu_step__SKopl"};